<div class="holiday-form-dialog bg-white rounded-[20px] p-6">
  <div class="flex items-center justify-between mb-6">
    <h2 class="text-[40px] leading-none text-xl font-semibold text-primary-dark">{{ title }}</h2>
    <button
      type="button"
      class="w-8 h-8 rounded-full text-gray-500 hover:bg-gray-100 transition-colors"
      aria-label="Fechar"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="isLoading" class="py-16 flex justify-center text-primary-gray">
    Carregando dados...
  </div>

  <form *ngIf="!isLoading" [formGroup]="form" class="flex flex-col gap-4" (ngSubmit)="submit()">
    <div>
      <label class="input-label">Tipo do Feriado <span class="text-red-600">*</span></label>
      <div class="flex flex-col gap-2">
        <label *ngFor="let type of holidayTypes" class="flex items-center gap-2 text-base leading-6 text-primary-dark">
          <input type="radio" formControlName="type" [value]="type" class="w-4 h-4" />
          <span>{{ type }}</span>
        </label>
      </div>
    </div>

    <div class="flex gap-2.5">
      <div class="flex-1">
        <label class="input-label">
          Estado
          <span *ngIf="form.controls.type.value !== 'Nacional'" class="text-red-600">*</span>
        </label>
        <ng-select
          class="holiday-select"
          formControlName="state"
          [items]="states"
          placeholder="Selecione um Estado"
          [searchable]="true"
          [clearable]="true"
          [closeOnSelect]="true"
          notFoundText="Nenhum estado encontrado"
        >
        </ng-select>
        <p *ngIf="form.controls.state.invalid && form.controls.state.touched" class="mt-1 text-xs text-red-600">
          O estado é obrigatório para o tipo selecionado.
        </p>
      </div>

      <div class="flex-1">
        <label class="input-label">
          Município
          <span *ngIf="form.controls.type.value === 'Municipal' && form.controls.state.value" class="text-red-600">*</span>
        </label>
        <ng-select
          class="holiday-select"
          formControlName="cityIbgeCode"
          [items]="municipalities"
          bindLabel="name"
          bindValue="ibgeCode"
          placeholder="Selecione um Município"
          [searchable]="true"
          [clearable]="true"
          [closeOnSelect]="true"
          notFoundText="Nenhum município encontrado"
        >
        </ng-select>
        <p
          *ngIf="form.controls.cityIbgeCode.errors?.['loadFailed'] && form.controls.cityIbgeCode.touched"
          class="mt-1 text-xs text-red-600"
        >
          Não foi possível carregar os municípios para este estado. Tente novamente.
        </p>
        <p
          *ngIf="form.controls.cityIbgeCode.invalid && form.controls.cityIbgeCode.touched && !form.controls.cityIbgeCode.errors?.['loadFailed']"
          class="mt-1 text-xs text-red-600"
        >
          O município é obrigatório para feriado municipal.
        </p>
      </div>
    </div>

    <div>
      <label class="input-label">Data do Feriado <span class="text-red-600">*</span></label>
      <div
        class="w-full border rounded-lg px-3 py-2.5 flex items-center gap-2 input-field-focus"
        [class.border-red-500]="form.controls.date.invalid && form.controls.date.touched"
      >
        <input
          formControlName="date"
          [matDatepicker]="holidayDatePicker"
          (click)="holidayDatePicker.open()"
          readonly
          placeholder="Selecione a Data do Feriado"
          class="w-full bg-transparent cursor-pointer"
        />
        <button type="button" class="text-gray-500" aria-label="Abrir calendário" (click)="holidayDatePicker.open()">
          <mat-icon>calendar_today</mat-icon>
        </button>
      </div>
      <mat-datepicker #holidayDatePicker></mat-datepicker>
      <p *ngIf="form.controls.date.invalid && form.controls.date.touched" class="mt-1 text-xs text-red-600">
        A data do feriado é obrigatória.
      </p>
    </div>

    <div>
      <label class="input-label">Motivo do Feriado <span class="text-red-600">*</span></label>
      <input
        type="text"
        formControlName="reason"
        placeholder="Ex: Aniversário da Cidade, Padroeiro da Cidade"
        class="w-full px-3 py-2.5 border rounded-lg input-field-focus"
        [class.border-red-500]="form.controls.reason.invalid && form.controls.reason.touched"
      />
      <p *ngIf="form.controls.reason.invalid && form.controls.reason.touched" class="mt-1 text-xs text-red-600">
        O motivo do feriado é obrigatório e não pode conter apenas espaços.
      </p>
    </div>

    <div class="flex items-center justify-between gap-3 pt-1 pb-2">
      <p class="text-base leading-6 text-primary-dark">Este feriado se repete todos os anos?</p>
      <app-custom-toggle formControlName="isRecurring"></app-custom-toggle>
    </div>

    <button
      type="submit"
      [disabled]="isSubmitting"
      class="w-full rounded-lg bg-primary text-white py-3 font-medium disabled:opacity-60 disabled:cursor-not-allowed"
    >
      {{ isSubmitting ? 'Salvando...' : 'Salvar Feriado' }}
    </button>
  </form>
</div>
